function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.function.bind.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import React, { Component } from 'react';

/* Set dropzoneDisabled prop to true to conditionally disable the enhancer functionality */

var getDisplayName = function getDisplayName(Comp) {
  return Comp.displayName || Comp.name || 'Component';
};
var dropzoneEnhancer = function dropzoneEnhancer(WrappedComponent) {
  if (!WrappedComponent) {
    throw new Error('dropzoneEnhancer needs a component to wrap!');
  }
  var Dropzone = /*#__PURE__*/function (_Component) {
    _inherits(Dropzone, _Component);
    var _super = _createSuper(Dropzone);
    function Dropzone(props) {
      var _this;
      _classCallCheck(this, Dropzone);
      _this = _super.call(this, props);
      _this.windowCount = 0;
      _this.count = 0;
      _this.listenersActive = false;
      _this.zone = null;
      _this.preventDefault = function (event) {
        return event.preventDefault();
      };
      _this.state = {
        dragging: false,
        hovering: false
      };
      _this.addListeners = _this.addListeners.bind(_assertThisInitialized(_this));
      _this.removeListeners = _this.removeListeners.bind(_assertThisInitialized(_this));
      _this.windowOnDragEnter = _this.windowOnDragEnter.bind(_assertThisInitialized(_this));
      _this.windowOnDragLeave = _this.windowOnDragLeave.bind(_assertThisInitialized(_this));
      _this.windowOnDragEnd = _this.windowOnDragEnd.bind(_assertThisInitialized(_this));
      _this.componentOnDragEnter = _this.componentOnDragEnter.bind(_assertThisInitialized(_this));
      _this.componentOnDragLeave = _this.componentOnDragLeave.bind(_assertThisInitialized(_this));
      _this.componentOnDrop = _this.componentOnDrop.bind(_assertThisInitialized(_this));
      return _this;
    }
    _createClass(Dropzone, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        if (!this.props.dropzoneDisabled) this.addListeners();
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.removeListeners();
      }

      // eslint-disable-next-line react/no-deprecated
    }, {
      key: "componentWillReceiveProps",
      value: function componentWillReceiveProps(nextProps) {
        if (this.props.dropzoneDisabled !== nextProps.dropzoneDisabled) {
          if (nextProps.dropzoneDisabled) {
            this.removeListeners();
            this.windowCount = 0;
            this.count = 0;
            this.setState({
              dragging: false,
              hovering: false
            });
          } else {
            this.addListeners();
          }
        }
      }
    }, {
      key: "addListeners",
      value: function addListeners() {
        if (this.listenersActive) return;
        this.listenersActive = true;
        window.addEventListener('dragenter', this.windowOnDragEnter, false);
        window.addEventListener('dragleave', this.windowOnDragLeave, false);
        window.addEventListener('dragend', this.windowOnDragEnd, false);
        window.addEventListener('drop', this.windowOnDragEnd, false);
        document.addEventListener('dragover', this.preventDefault, false);
        document.addEventListener('drop', this.preventDefault, false);
        this.zone.addEventListener('dragenter', this.componentOnDragEnter, false);
        this.zone.addEventListener('dragleave', this.componentOnDragLeave, false);
        this.zone.addEventListener('drop', this.componentOnDrop, false);
      }
    }, {
      key: "removeListeners",
      value: function removeListeners() {
        if (!this.listenersActive) return;
        this.listenersActive = false;
        window.removeEventListener('dragenter', this.windowOnDragEnter);
        window.removeEventListener('dragleave', this.windowOnDragLeave);
        window.removeEventListener('dragend', this.windowOnDragEnd);
        window.removeEventListener('drop', this.windowOnDragEnd);
        document.removeEventListener('dragover', this.preventDefault);
        document.removeEventListener('drop', this.preventDefault);
        this.zone.removeEventListener('dragenter', this.componentOnDragEnter);
        this.zone.removeEventListener('dragleave', this.componentOnDragLeave);
        this.zone.removeEventListener('drop', this.componentOnDrop);
      }
    }, {
      key: "windowOnDragEnter",
      value: function windowOnDragEnter(event) {
        if (event) event.preventDefault();
        this.windowCount++;
        if (!this.state.dragging) {
          this.setState({
            dragging: true
          });
        }
      }
    }, {
      key: "windowOnDragLeave",
      value: function windowOnDragLeave(event) {
        if (event) event.preventDefault();
        this.windowCount--;
        if (this.windowCount < 0) this.windowCount = 0;
        if (this.state.dragging && !this.windowCount) {
          this.setState({
            dragging: false
          });
        }
      }
    }, {
      key: "windowOnDragEnd",
      value: function windowOnDragEnd(event) {
        if (event) event.preventDefault();
        this.windowCount = 0;
        this.setState({
          dragging: false
        });
      }
    }, {
      key: "componentOnDragEnter",
      value: function componentOnDragEnter(event) {
        if (event) event.preventDefault();
        this.count++;
        if (!this.state.hovering) {
          this.setState({
            hovering: true
          });
        }
      }
    }, {
      key: "componentOnDragLeave",
      value: function componentOnDragLeave(event) {
        if (event) event.preventDefault();
        this.count--;
        if (this.count < 0) this.count = 0;
        if (this.state.hovering && !this.count) {
          this.setState({
            hovering: false
          });
        }
      }
    }, {
      key: "componentOnDrop",
      value: function componentOnDrop(event) {
        if (event) event.preventDefault();
        this.count = 0;
        this.setState({
          hovering: false
        });
        if (this.props.onDrop && typeof this.props.onDrop === 'function') {
          this.props.onDrop(event.dataTransfer.files);
        } else {
          console.warn('invalid onDrop prop for the dropzone wrapper.');
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;
        return /*#__PURE__*/React.createElement("div", {
          className: "dropzone-wrapper",
          ref: function ref(element) {
            _this2.zone = element;
          }
        }, /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, this.props, {
          dropzoneDragging: this.state.dragging,
          dropzoneHovering: this.state.hovering
        })));
      }
    }]);
    return Dropzone;
  }(Component); // @ts-expect-error TODO
  Dropzone.displayName = "Dropzone(".concat(getDisplayName(WrappedComponent), ")");
  return Dropzone;
};
export default dropzoneEnhancer;